import script from "./FairLaunchBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./FairLaunchBanner.vue?vue&type=script&setup=true&lang=ts"

import "./FairLaunchBanner.vue?vue&type=style&index=0&id=74307a94&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74307a94"]])

export default __exports__